import { Button, IconButton, Stack, TableCell, TableRow } from "@mui/material";
import { capitalCase } from "change-case";
import { useNavigate } from "react-router";
import ParseDate from "src/components/date";
import Iconify from "src/components/Iconify";
import Ternary from "src/components/ternary";
import Translate from "src/components/translate";
import { PATH_DASHBOARD } from "src/routes/paths";

const Row = ({
  handleOpenApproved,
  handleOpenRejected,
  handleOpenMenu,
  item,
  rowNumber,
}) => {
  const navigate = useNavigate()
  return (
    <TableRow>
      <TableCell>{rowNumber}</TableCell>

      <TableCell>{item?.user?.username}</TableCell>
      <TableCell>{item?.user?.user_profile?.first_name}</TableCell>
      <TableCell>{item?.user?.user_profile?.last_name}</TableCell>
      <TableCell>{capitalCase(item?.status)}</TableCell>
      <TableCell>{item?.address}</TableCell>

      <TableCell>{item?.remarks}</TableCell>

      <TableCell>
        <ParseDate date={item?.created_at} />{" "}
      </TableCell>

      <TableCell>
        <Ternary
          when={Boolean(item?.user?.is_retail_partner)}
          then={
            <IconButton
              edge="end"
              onClick={() =>
                navigate(PATH_DASHBOARD.store.partner_products(item?.id))
              }
            >
              <Iconify icon={"eva:eye-fill"} />
            </IconButton>
          }
          otherwise={
            "-"
          }
        />
      </TableCell>
      <TableCell>
        <Stack direction="row" spacing={2}>
          <Button
            size="small"
            disabled={
              item?.status === "approved" || item?.status === "rejected"
            }
            onClick={() => handleOpenApproved(item.id)}
            startIcon={<Iconify icon="akar-icons:check" />}
            variant="contained"
            name="payout-approve"
          >
            <Translate>Approve</Translate>
          </Button>
          <Button
            disabled={
              item?.status === "rejected" || item?.status === "approved"
            }
            size="small"
            onClick={() => handleOpenRejected(item.id)}
            startIcon={<Iconify icon="ant-design:delete-outlined" />}
            color="error"
            variant="outlined"
          // name="payout-reject"
          >
            <Translate>Reject</Translate>
          </Button>
        </Stack>
      </TableCell>
      <TableCell>
        <IconButton onClick={handleOpenMenu(item?.user?.id)} name="more-button">
          <Iconify icon={"eva:more-vertical-fill"} width={20} height={20} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default Row;
